export default "__VITE_ASSET__75fc3423__"